import {Avatar} from "@ui";
import PropTypes from "prop-types";
import {useState} from "react";
import {useNavigate} from "react-router-dom";
import userIcon from "../../../assets/images/icon_user.svg";
import useGetUserInfo from "../../../hooks/useGetUserInfo";
import {useAuthStore} from "../../../store/useAuth.store";
import {getUserAvatarImage, getUserInitials} from "../../../util/avatarUtils";
import UserMenu from "../UserMenu";
import styles from "./avatar.module.css";

const UserAvatar = ({size = 40}) => {
  const navigate = useNavigate();

  const {data, isLoading} = useGetUserInfo();
  const logout = useAuthStore(state => state.logout);
  const [imageError, setImageError] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  const handleImageError = () => {
    setImageError(true);
  };

  const userInitials = getUserInitials(data);
  const avatarImage = getUserAvatarImage(data);

  return (
    <UserMenu handleLogout={handleLogout}>
      <Avatar
        size={size}
        className={styles.avatar_icon}
      >
        {isLoading ? (
          <span></span>
        ) : !imageError && avatarImage ? (
          <img
            src={avatarImage || userIcon}
            alt="User Avatar"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "50%",
            }}
            onError={handleImageError}
          />
        ) : (
          <span>{userInitials}</span>
        )}
      </Avatar>
    </UserMenu>
  );
};

UserAvatar.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default UserAvatar;
